export default __webpack_public_path__ + "static/media/sending_points.7ccd7aa3.png";